import './base';
import {
  showMessage,
  logMessage
} from './src/utils';
import {
  search
} from './src/search';
import Splide from '@splidejs/splide';
import './src/main-tabs';


const searchInput = document.querySelector('#catalog-search');
searchInput.addEventListener('click', function () {
  window.scrollTo(0, 0);
  search.show();
});

new Splide('.main-slider', {
  type: 'loop',
  perPage: 1,
  autoplay: true,
  arrowPath: 'M16.802 19.9948L31.7358 4.87181C32.8402 3.75247 32.8402 1.94248 31.7358 0.835045C30.6313 -0.284294 28.8454 -0.272386 27.7409 0.835045L10.8215 17.9705C9.75229 19.0541 9.7288 20.7926 10.7393 21.912L27.7291 39.1664C28.2814 39.7261 29.0099 40 29.7266 40C30.4433 40 31.1718 39.7261 31.724 39.1664C32.8285 38.0471 32.8285 36.2371 31.724 35.1297L16.802 19.9948Z',
  classes: {
    arrows: 'splide__arrows main-slider__arrows',
    arrow: 'splide__arrow main-slider__arrow',
    prev: 'splide__arrow--prev main-slider__arrow--prev',
    next: 'splide__arrow--next main-slider__arrow--next',
    pagination: 'splide__pagination main-slider__pagination',
  },
}).mount();

new Splide('.main-reviews__slider', {
  perPage: 3,
  perMove: 1,
  arrowPath: 'M16.802 19.9948L31.7358 4.87181C32.8402 3.75247 32.8402 1.94248 31.7358 0.835045C30.6313 -0.284294 28.8454 -0.272386 27.7409 0.835045L10.8215 17.9705C9.75229 19.0541 9.7288 20.7926 10.7393 21.912L27.7291 39.1664C28.2814 39.7261 29.0099 40 29.7266 40C30.4433 40 31.1718 39.7261 31.724 39.1664C32.8285 38.0471 32.8285 36.2371 31.724 35.1297L16.802 19.9948Z',
  classes: {
    arrows: 'splide__arrows main-reviews__arrows',
    arrow: 'splide__arrow main-reviews__arrow',
    prev: 'splide__arrow--prev main-reviews__arrow--prev',
    next: 'splide__arrow--next main-reviews__arrow--next',
    pagination: 'splide__pagination main-reviews__pagination',
  },
  gap: '20px',
  breakpoints: {
    '991': {
      perPage: 2,
      gap: '20px',
    },
    '767': {
      perPage: 1,
      gap: '15px',
    },
  }
}).mount();

new Splide('.main-brands__slider', {
  arrowPath: 'M16.802 19.9948L31.7358 4.87181C32.8402 3.75247 32.8402 1.94248 31.7358 0.835045C30.6313 -0.284294 28.8454 -0.272386 27.7409 0.835045L10.8215 17.9705C9.75229 19.0541 9.7288 20.7926 10.7393 21.912L27.7291 39.1664C28.2814 39.7261 29.0099 40 29.7266 40C30.4433 40 31.1718 39.7261 31.724 39.1664C32.8285 38.0471 32.8285 36.2371 31.724 35.1297L16.802 19.9948Z',
  classes: {
    arrows: 'splide__arrows main-brands__arrows',
    arrow: 'splide__arrow main-brands__arrow',
    prev: 'splide__arrow--prev main-brands__arrow--prev',
    next: 'splide__arrow--next main-brands__arrow--next',
    pagination: 'splide__pagination main-brands__pagination',
  },
  perPage: 1,
  gap: '20px',
  mediaQuery: 'min',
  breakpoints: {
    '768': {
      destroy: true
    },
  },
}).mount();
